import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  alpha,
} from "@mui/material";
import { Public as PublicIcon } from "@mui/icons-material";
import { UpdateGfStoreDto } from "@swagger/typescript-fetch-goflyer";
import { FieldPath, FieldValue } from "../utils/fieldChangeHelpers";
import { useTranslation } from "react-i18next";
import { messages } from "../../../../locales/messages";

interface GeographicCoordinatesProps {
  store?: UpdateGfStoreDto;
  isEditing: boolean;
  onFieldChange: (field: FieldPath, value: FieldValue) => void;
}

export const GeographicCoordinates: React.FC<GeographicCoordinatesProps> = ({
  store,
  isEditing,
  onFieldChange,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      elevation={1}
      sx={{
        borderRadius: 3,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        border: "1px solid",
        borderColor: alpha("#000", 0.06),
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" mb={2}>
          <PublicIcon sx={{ color: "#f58321", mr: 1 }} />{" "}
          <Typography variant="h6" fontWeight={600}>
            {t(messages.Geographic_Coordinates())}
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box>
              {" "}
              <Typography variant="subtitle2" color="text.secondary" mb={0.5}>
                {t(messages.Longitude())}
              </Typography>
              {isEditing ? (
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="-122.4194"
                  value={store?.location?.coordinates?.[0] || ""}
                  onChange={(e) => {
                    const newCoordinates = [
                      ...(store?.location?.coordinates || [0, 0]),
                    ];
                    newCoordinates[0] = parseFloat(e.target.value) || 0;
                    onFieldChange("location", {
                      ...store?.location,
                      coordinates: newCoordinates,
                    });
                  }}
                  variant="outlined"
                />
              ) : (
                <Typography variant="h6" fontWeight={500}>
                  {store?.location?.coordinates?.[0] ||
                    t(messages.Not_Available())}
                </Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box>
              {" "}
              <Typography variant="subtitle2" color="text.secondary" mb={0.5}>
                {t(messages.Latitude())}
              </Typography>
              {isEditing ? (
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="37.7749"
                  value={store?.location?.coordinates?.[1] || ""}
                  onChange={(e) => {
                    const newCoordinates = [
                      ...(store?.location?.coordinates || [0, 0]),
                    ];
                    newCoordinates[1] = parseFloat(e.target.value) || 0;
                    onFieldChange("location", {
                      ...store?.location,
                      coordinates: newCoordinates,
                    });
                  }}
                  variant="outlined"
                />
              ) : (
                <Typography variant="h6" fontWeight={500}>
                  {store?.location?.coordinates?.[1] ||
                    t(messages.Not_Available())}
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
